<tg-modal
    size="medium"
    (close)="onClose()">
    <tg-modal-header>
       <h2>Continue or start over?</h2>
    </tg-modal-header>

    <tg-modal-body
        class="start-over-modal-body">
        You have started the process of listing a property. Do you want to continue or start over?
    </tg-modal-body>

    <tg-modal-footer>
        <tg-row>
            <tg-col
                sm="6">
                <button
                    (click)="onClose()"
                    fullWidth
                    tgButton2
                    tgStyle="primary"
                    type="button">
                    Continue
                </button>
            </tg-col>
            <tg-col
                sm="6">
                <button
                    (click)="confirmCancel()"
                    fullWidth
                    tgButton2
                    type="button">
                    Start over
                </button>
            </tg-col>
        </tg-row>
    </tg-modal-footer>
</tg-modal>
